import React from "react";
import PropTypes from "prop-types";
import { Segment, Item, Title, Icon, Grid } from "semantic-ui-react";
import { ItemData, Paginate } from "../../components";
import Link from "next/link";
import { Iconstyle, IconstyleRed } from "./element";
import { relative } from "path";

import {
  get_converted_value,
  customdecodeURIComponent,
  getOrdinalSuffix,
} from "../../common/Utils";

const NhLists = ({
  itemData,
  selectedtab,
  cat,
  href,
  prev,
  active,
  header,
  getData,
  customclass,
  handleHover,
  handlenhclick,
  display,
  displaydatasummary,
  onClick,
  onsummaryClick,
  handleUnhover,
  is_saved,
  heart,
  save,
  personal_txt,
  personalizationdata,
  userId,
  isMobile,
  handlefilterclick,
  isEnabled,
  ...props
}) => {
  let data = itemData.length;

  const newArray =
    itemData &&
    itemData.length > 0 &&
    itemData.map((obj, index) => ({ ...obj, number: index + 1 }));
  let page_size = isMobile && props.ispage === "nhmap" ? 15 : 3;
  let indexdata = (active - 1) * page_size;
  // let school_val = 40;
  // let crime_val = 40;
  // let walk_val = 20;
  // let town_val = 0;
  // let curb_val = 0;
  // let com_val = 0;

  // let w_sum = school_val + crime_val + walk_val + town_val + curb_val + com_val;

  // let w1 = school_val/w_sum //school
  // let w2 = crime_val/w_sum //safery
  // let w3 = walk_val/w_sum //walkability
  // let w4 = town_val/w_sum //town
  // let w5 = curb_val/w_sum //curb
  // let w6 = com_val/w_sum //community

  // let maxschoolfacor = 10.0;
  // let maxwalkfacor = 10.0;
  // let maxsafefacor = 10.0;
  // let maxtownfacor = 10.0;
  // let maxcurbfacor = 10.0;
  // let maxcomfacor = 10.0;

  // let finalresultnpi = 0;
  {
  }
  function sliceWithSpaces(final_summary, additional_txt) {
    let textWithoutSpaces = final_summary.replace(/\s+/g, "");

    let sliceLength = additional_txt ? 90 : 100;
    let slicedWithoutSpaces = textWithoutSpaces.slice(0, sliceLength);
    let displayedText = "";
    let index = 0;

    for (let i = 0; i < final_summary.length; i++) {
      displayedText += final_summary[i];
      if (index < slicedWithoutSpaces.length && final_summary[i] !== " ") {
        index++;
      }
      if (index >= slicedWithoutSpaces.length) {
        break;
      }
    }
    return displayedText;
  }

  return (
    <Segment
      basic
      style={{ paddingLeft: "1px" }}
      className={
        !isMobile
          ? newArray && newArray.length !== 0
            ? "neighbor_top open"
            : "neighbor_top"
          : ""
      }
    >
      {newArray && newArray.length !== 0 && (
        <Item.Group>
          {newArray
            .slice(indexdata)
            .slice(0, page_size)
            .map((item, index) => {
              if (item !== null) {
                if (item.name !== undefined) {
                  let additional_txt = "";
                  let additional_value = "";

                  let personalnpival = "";

                  //if (item.personalNpi && userId !== "" && userId !== null) {
                  if (item.personalNpi) {
                    personalnpival = Number(
                      ((item.personalNpi / 100) * 5).toFixed(2)
                    ).toFixed(1);
                  } else if (
                    /*Personal Score Calculation Start */
                    personalizationdata &&
                    personalizationdata.length > 0 &&
                    cat === "saved" &&
                    userId !== "" &&
                    userId !== null
                  ) {
                    let schoolsdata = personalizationdata[0].schoolScore / 10;
                    let safetydata = personalizationdata[0].crimeRate / 10;
                    let walkabilitydata =
                      personalizationdata[0].walkability / 10;
                    let publicspacesdata =
                      personalizationdata[0].publicspaces / 10;
                    let curbAppealdata = personalizationdata[0].curbAppeal / 10;
                    let valueindexdata = personalizationdata[0].valueIndex / 10;
                    // let minpricedata = prsonaldata.pricemin;
                    // let maxpricedata = prsonaldata.pricemax;

                    var sumOfWeights = 0;

                    if (item.school > 0) {
                      sumOfWeights += Number(schoolsdata);
                    }
                    if (item.crime > 0) {
                      sumOfWeights += Number(safetydata);
                    }
                    if (item.walkability > 0) {
                      sumOfWeights += Number(walkabilitydata);
                    }
                    if (item.publicspaces > 0) {
                      sumOfWeights += Number(publicspacesdata);
                    }
                    if (item.curb > 0) {
                      sumOfWeights += Number(curbAppealdata);
                    }

                    var targetFactorWeights = {
                      schools: schoolsdata / sumOfWeights,
                      safety: safetydata / sumOfWeights,
                      walkability: walkabilitydata / sumOfWeights,
                      publicspaces: publicspacesdata / sumOfWeights,
                      curbAppeal: curbAppealdata / sumOfWeights,
                      elementarySchool: 0,
                      middleSchool: 0,
                      highSchool: 0,
                      neighborhoodValueIndexs: valueindexdata / sumOfWeights,
                    };

                    var targetRadiusFromSearchLocations = 0; // in miles
                    var targetSearchLocationLats;
                    var targetSearchLocationLongs;
                    var targetMinPrices = 0;
                    var targetMaxPrices = 0;

                    const minPriceAdjustments = 0.85;
                    const maxPriceAdjustments = 1.15;
                    const minRadiuss = 5.0; // in miles
                    const bayAreaNeighborhoodMinimumMedianPrices = 500000.0; // benchmarked to median home price for Antioch
                    const maxNviScaleFactors = 0.096;
                    if (targetRadiusFromSearchLocations < minRadiuss) {
                      targetRadiusFromSearchLocations = minRadiuss;
                    }
                    targetMinPrices *= minPriceAdjustments;
                    targetMaxPrices *= maxPriceAdjustments;

                    targetFactorWeights["neighborhoodValueIndexs"] =
                      personalizationdata[0].valueIndex / 10 / sumOfWeights;

                    targetFactorWeights["schools"] =
                      personalizationdata[0].schoolScore / 10 / sumOfWeights;

                    // Copy school weight into elementarySchool, middleSchool, highSchool
                    targetFactorWeights["elementarySchool"] =
                      targetFactorWeights["schools"];
                    targetFactorWeights["middleSchool"] =
                      targetFactorWeights["schools"];
                    targetFactorWeights["highSchool"] =
                      targetFactorWeights["schools"];
                    //let neighborhoodValueIndexs = parseFloat(item.value) / 10;
                    let neighborhoodValueIndexs = get_converted_value(
                      parseFloat(item.value)
                    );

                    personalnpival =
                      parseFloat(
                        parseFloat(item.school) *
                          targetFactorWeights["schools"] +
                          parseFloat(item.publicspaces) *
                            targetFactorWeights["publicspaces"] +
                          parseFloat(item.crime) *
                            targetFactorWeights["safety"] +
                          parseFloat(item.curb) *
                            targetFactorWeights["curbAppeal"] +
                          parseFloat(item.walkability) *
                            targetFactorWeights["walkability"]
                      ) * 10;

                    if (!Number.isNaN(personalnpival)) {
                      personalnpival = Number(
                        ((personalnpival / 100) * 5).toFixed(2)
                      ).toFixed(1);
                    } else {
                      personalnpival = "-";
                    }

                    // let neighborhoodValueIndexs =
                    //   (parseFloat(item.npi) / 10) *
                    //   (bayAreaNeighborhoodMinimumMedianPrices /
                    //     item.medianprice);
                    // personalnpival = Math.round(
                    //   parseFloat(
                    //     (parseFloat(item.primaryschoolscore) *
                    //       targetFactorWeights["elementarySchool"]) /
                    //       3.0 +
                    //       (parseFloat(item.middleschoolscore) *
                    //         targetFactorWeights["middleSchool"]) /
                    //         3.0 +
                    //       (parseFloat(item.highschoolscore) *
                    //         targetFactorWeights["highSchool"]) /
                    //         3.0 +
                    //       parseFloat(item.community) *
                    //         targetFactorWeights["community"] +
                    //       parseFloat(item.crime) *
                    //         targetFactorWeights["safety"] +
                    //       parseFloat(item.curb) *
                    //         targetFactorWeights["curbAppeal"] +
                    //       parseFloat(item.walkability) *
                    //         targetFactorWeights["walkability"] +
                    //       neighborhoodValueIndexs *
                    //         targetFactorWeights["neighborhoodValueIndexs"] *
                    //         maxNviScaleFactors
                    //   ) * 10
                    // );
                  } else {
                    personalnpival = "-";
                  }
                  /*Personal Score Calculation Warp */
                  // if (cat === "top" || cat === "saved") {
                  if (selectedtab === 2 || selectedtab === 8) {
                    additional_txt = "School";
                    additional_value = item.school;
                    additional_value = Number(
                      ((additional_value / 10) * 5).toFixed(2)
                    ).toFixed(1);
                  }

                  if (selectedtab === 9) {
                    additional_txt = "Elementary School";
                    additional_value = item.primaryschoolscore;
                    additional_value = Number(
                      ((additional_value / 10) * 5).toFixed(2)
                    ).toFixed(1);
                  }

                  if (selectedtab === 10) {
                    additional_txt = "Middle School";
                    additional_value = item.middleschoolscore;
                    additional_value = Number(
                      ((additional_value / 10) * 5).toFixed(2)
                    ).toFixed(1);
                  }
                  if (selectedtab === 11) {
                    additional_txt = "High School";
                    additional_value = item.highschoolscore;
                    additional_value = Number(
                      ((additional_value / 10) * 5).toFixed(2)
                    ).toFixed(1);
                  }
                  if (selectedtab === 3) {
                    additional_txt = "Safety";
                    additional_value = item.crime;
                    additional_value = Number(
                      ((additional_value / 10) * 5).toFixed(2)
                    ).toFixed(1);
                  }

                  if (selectedtab === 4 || selectedtab === 16) {
                    additional_txt = "Amentities";
                    if (item.amenities > 0) {
                      additional_value = item.amenities;
                    } else if (item.walkability > 0) {
                      additional_value = Number(
                        ((item.walkability / 10) * 5).toFixed(2)
                      ).toFixed(1);
                    } else {
                      additional_value = "-";
                    }
                  }

                  // if (selectedtab === 8) {
                  //   additional_txt = "TownCtr";
                  //   additional_value = "-";
                  // }
                  if (selectedtab === 5 || selectedtab === 18) {
                    additional_txt = "Price";
                    if (item.medianprice > 0) {
                      additional_value =
                        "$" + Math.round(item.medianprice).toLocaleString();
                    } else {
                      additional_value = "-";
                    }
                  }
                  if (selectedtab === 6) {
                    // additional_txt = "Appreciation";
                    // if (item.appreciation !== 0) {
                    //   additional_value = Math.round(item.appreciation) + "%";
                    // } else {
                    //   additional_value = "-";
                    // }
                  }

                  if (selectedtab === 7) {
                    additional_txt = "Appreciation";
                    if (item.appreciation && item.appreciation !== 0) {
                      additional_value = Math.round(item.appreciation) + "%";
                    } else {
                      additional_value = "-";
                    }
                  }
                  if (selectedtab === 1) {
                    additional_txt = "Personal";
                    additional_value = item.personalNpi || personalnpival;
                    if (item.personalNpi) {
                      additional_value = Number(
                        ((additional_value / 100) * 5).toFixed(2)
                      ).toFixed(1);
                    }
                  }

                  if (selectedtab === 12) {
                    additional_txt = "Near Merchants";
                    additional_value = item.walkability;
                    if (additional_value > 0) {
                      additional_value = Number(
                        ((additional_value / 10) * 5).toFixed(2)
                      ).toFixed(1);
                    } else {
                      additional_value = "-";
                    }
                  }
                  if (selectedtab === 13) {
                    additional_txt = "Public Spaces";
                    if (item.publicspaces > 0) {
                      additional_value = item.publicspaces;
                    } else {
                      additional_value = "-";
                    }
                  }
                  if (selectedtab === 14) {
                    additional_txt = "Walkable Street";
                    if (item.others > 0) {
                      additional_value = item.others;
                    } else {
                      additional_value = "-";
                    }
                  }
                  if (selectedtab === 15) {
                    additional_txt = "Curb Appeal";
                    if (item.curb > 0) {
                      additional_value = item.curb;
                    } else {
                      additional_value = "-";
                    }
                  }
                  // }

                  let npiscore = 0;
                  let valuescore = 0;
                  let schoolscore = 0;
                  let crimescore = 0;
                  let walkscore = 0;
                  let medianprice = 0;
                  let townctrscore = 0;
                  let publicscore = 0;
                  let walkablesteetscore = 0;
                  let amenitiesscore = 0;
                  let curbscore = 0;
                  let valuedata = 0;

                  if (item.school) {
                    schoolscore = item.school;
                    schoolscore = Number(
                      ((schoolscore / 10) * 5).toFixed(2)
                    ).toFixed(1);
                  }
                  if (item.medianprice && item.medianprice > 0) {
                    medianprice =
                      "$" + Math.round(item.medianprice).toLocaleString();
                  } else {
                    medianprice = "-";
                  }
                  if (item.crime) {
                    crimescore = item.crime;
                    crimescore = Number(
                      ((crimescore / 10) * 5).toFixed(2)
                    ).toFixed(1);
                  }
                  if (item.walkability) {
                    walkscore = item.walkability;
                    walkscore = Number(
                      ((walkscore / 10) * 5).toFixed(2)
                    ).toFixed(1);
                  }
                  if (cat === "top" || cat === "saved") {
                    // let s1 = parseFloat(schoolscore).toFixed(1)/maxsafefacor;
                    // let s2 = parseFloat(crimescore).toFixed(1)/maxschoolfacor;
                    // let s3 = parseFloat(walkscore).toFixed(1)/maxwalkfacor;
                    // let s4 = 0;
                    // let s5 = 0;
                    // let s6 = 0;

                    // finalresultnpi = ( (w1*s1) + (w2*s2) + (w3*s3) + (w4*s4) + (w5*s5) + (w6*s6)).toFixed(1) * 10

                    // if(item.npi <= 0.9){
                    // 	npiscore = parseFloat(item.npi).toFixed(1)*10;

                    // }else{
                    // 	npiscore = item.npi*10;

                    // }

                    npiscore = item.npi;
                    npiscore = Number(
                      ((item.npi / 100) * 5).toFixed(2)
                    ).toFixed(1);

                    // if(item.value <= 0.9){
                    // 	valuescore = parseFloat(item.value).toFixed(1)*10;
                    // }else{
                    // 	valuescore = item.value*10;
                    // }

                    if (item.value) {
                      valuescore = parseInt(item.value);
                      valuedata = parseInt(item.value);
                      valuescore = "$" + valuescore.toLocaleString();
                      valuescore = valuescore.replace("-", "");
                      // valuescore = Number(
                      //   ((item.value / 100) * 5).toFixed(2)
                      // ).toFixed(1);
                    } else {
                      valuescore = "-";
                      valuedata = "-";
                    }
                    if (selectedtab === 6) {
                      additional_txt = "Value";
                      additional_value = valuescore;
                    }
                    if (selectedtab === 0) {
                      additional_txt = "Overall";
                      additional_value = npiscore;
                    }
                  } else {
                    // let s1 = parseFloat(schoolscore).toFixed(1)/maxsafefacor;
                    // let s2 = parseFloat(crimescore).toFixed(1)/maxschoolfacor;
                    // let s3 = parseFloat(walkscore).toFixed(1)/maxwalkfacor;
                    // let s4 = 0;
                    // let s5 = 0;
                    // let s6 = 0;

                    // finalresultnpi = ( (w1*s1) + (w2*s2) + (w3*s3) + (w4*s4) + (w5*s5) + (w6*s6)).toFixed(1) * 10
                    npiscore = item.npi;
                    npiscore = Number(
                      ((item.npi / 100) * 5).toFixed(2)
                    ).toFixed(1);
                    if (item.value) {
                      valuescore = item.value;
                      valuescore = valuescore.replace("-", "");
                      // valuescore = Number(
                      //   ((item.value / 100) * 5).toFixed(2)
                      // ).toFixed(1);
                    } else {
                      valuescore = "-";
                    }
                  }

                  if (item.walkability > 0) {
                    townctrscore = Number(
                      ((item.walkability / 10) * 5).toFixed(2)
                    ).toFixed(1);
                  } else {
                    townctrscore = "-";
                  }

                  if (item.publicspaces > 0) {
                    publicscore = item.publicspaces;
                  } else {
                    publicscore = "-";
                  }

                  if (item.others > 0) {
                    walkablesteetscore = item.others;
                  } else {
                    walkablesteetscore = "-";
                  }

                  if (item.amenities > 0) {
                    amenitiesscore = item.amenities;
                  } else if (item.walkability > 0) {
                    amenitiesscore = Number(
                      ((item.walkability / 10) * 5).toFixed(2)
                    ).toFixed(1);
                  } else {
                    amenitiesscore = "-";
                  }

                  if (item.curb > 0) {
                    curbscore = item.curb;
                  } else {
                    curbscore = "-";
                  }
                  let nhid = "";
                  if (is_saved) {
                    nhid = item.neighborhoodId;
                  } else {
                    nhid = item.id;
                  }

                  let final_summary = "";
                  if (item.summary && item.summary !== null) {
                    final_summary = customdecodeURIComponent(item.summary);
                  } else if (item.nhsummary && item.nhsummary.length > 0) {
                    final_summary = customdecodeURIComponent(
                      item.nhsummary[0].summary
                    );
                  }

                  let thumbanail = "";
                  if (item.thumbnailurl && item.thumbnailurl !== null) {
                    thumbanail = item.thumbnailurl;
                  } else if (
                    item.neighborhoodImages &&
                    item.neighborhoodImages.length > 0 &&
                    item.neighborhoodImages[0].thumbnailurl
                  ) {
                    thumbanail = item.neighborhoodImages[0].thumbnailurl;
                  }
                  let final_index = item.id + index;
                  let final_summary_index = "summary_" + item.id + index;
                  let displaykey = process.env.NEXT_PUBLIC_DISPLAY_DATA;

                  return (
                    <>
                      {item[displaykey] === 1 ? (
                        <Item
                          key={(Date.now() + item.id + index).toString()}
                          style={{ position: "relative" }}
                          className="nhlist_items"
                        >
                          <div className="nh_ranking_list_mb">
                            <div style={{ marginTop: 0 }}>
                              <div className="nh_ranking_rating">
                                {item.number}
                                <sup className="nh_ranking_suffix">
                                  {getOrdinalSuffix(item.number)}
                                </sup>
                              </div>
                            </div>

                            {thumbanail != "" ? (
                              <a
                                style={{
                                  cursor: "pointer",
                                  marginRight: 20,
                                  marginLeft: 5,
                                }}
                                target="_blank"
                                onMouseEnter={() => handleHover(nhid)}
                                onMouseLeave={() => handleUnhover(nhid)}
                                onClick={() =>
                                  handlenhclick(nhid, cat, item?.nhfullname)
                                }
                                ondblclick={() =>
                                  handledbclick(item?.nhfullname)
                                }
                              >
                                <Item.Image
                                  className="nhpannel_img"
                                  src={thumbanail}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      process.env.NEXT_PUBLIC_CDN_ID +
                                      "static/images/defaultnhmap.jpg";
                                  }}
                                />
                                <div
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    width: "100%",
                                    height: "auto",
                                  }}
                                >
                                  <>
                                    {" "}
                                    {heart[item.id] ? (
                                      <span
                                        onClick={(e) => {
                                          save(item.id, item, cat);
                                          e.stopPropagation();
                                          e.preventDefault();
                                        }}
                                        onMouseEnter={() => handleHover(nhid)}
                                        onMouseLeave={() => handleUnhover(nhid)}
                                      >
                                        <Icon
                                          size="big"
                                          name="heart"
                                          //color="#c02e26"
                                          style={IconstyleRed}
                                        />
                                      </span>
                                    ) : (
                                      <span
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          e.preventDefault();
                                          save(item.id, item, cat);
                                        }}
                                        onMouseEnter={() => handleHover(nhid)}
                                        onMouseLeave={() => handleUnhover(nhid)}
                                      >
                                        <Icon
                                          size="big"
                                          name="heart outline"
                                          style={Iconstyle}
                                        />
                                      </span>
                                    )}
                                  </>
                                </div>
                              </a>
                            ) : (
                              <a
                                style={{
                                  cursor: "pointer",
                                  marginRight: 20,
                                  marginLeft: 5,
                                }}
                                target="_blank"
                                onMouseEnter={() => handleHover(nhid)}
                                onMouseLeave={() => handleUnhover(nhid)}
                                onClick={() =>
                                  handlenhclick(nhid, cat, item?.nhfullname)
                                }
                                ondblclick={() =>
                                  handledbclick(item?.nhfullname)
                                }
                              >
                                <Item.Image
                                  className="nhpannel_img"
                                  src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/defaultnhmap.jpg`}
                                />
                                <div
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    width: "100%",
                                    height: "auto",
                                  }}
                                >
                                  <>
                                    {" "}
                                    {heart[item.id] ? (
                                      <span
                                        onClick={(e) => {
                                          save(item.id, item, cat);
                                          e.stopPropagation();
                                          e.preventDefault();
                                        }}
                                        onMouseEnter={() => handleHover(nhid)}
                                        onMouseLeave={() => handleUnhover(nhid)}
                                      >
                                        <Icon
                                          size="big"
                                          name="heart"
                                          //color="#c02e26"
                                          style={IconstyleRed}
                                        />
                                      </span>
                                    ) : (
                                      <span
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          e.preventDefault();
                                          save(item.id, item, cat);
                                        }}
                                        onMouseEnter={() => handleHover(nhid)}
                                        onMouseLeave={() => handleUnhover(nhid)}
                                      >
                                        <Icon
                                          size="big"
                                          name="heart outline"
                                          style={Iconstyle}
                                        />
                                      </span>
                                    )}
                                  </>
                                </div>
                              </a>
                            )}
                            {/*<a style={{cursor:'pointer',marginRight: 20}} target="_blank"><Item.Image size='small' src={'/static/images/'+item.img_name}/></a>*/}
                            {/* <a style={{cursor:'pointer',marginRight: 20}} target="_blank"><Item.Image className="nhpannel_img" src='/static/images/defaultadd.jpg'/></a> */}
                          </div>
                          <Item.Content
                            className="right_content_top"
                            style={{ marginTop: 0 }}
                          >
                            {display[final_index] ? (
                              <>
                                {" "}
                                <Icon
                                  name="minus circle"
                                  size="small"
                                  onClick={(e) => onClick(e, final_index)}
                                />{" "}
                              </>
                            ) : (
                              <>
                                {" "}
                                <Icon
                                  className="plus-icon-items"
                                  name="plus circle"
                                  size="small"
                                  onClick={(e) => onClick(e, final_index)}
                                />{" "}
                              </>
                            )}
                            <div>
                              <a
                                // style={{ cursor: "pointer", marginLeft: 5 }}
                                target="_blank"
                                onMouseEnter={() => handleHover(nhid)}
                                onMouseLeave={() => handleUnhover(nhid)}
                                onClick={() =>
                                  handlenhclick(nhid, cat, item?.nhfullname)
                                }
                                ondblclick={() =>
                                  handledbclick(item?.nhfullname)
                                }
                                className="nh_raking_ref"
                              >
                                <Item.Header className="nhpannel_head">
                                  {item.name !== undefined
                                    ? !isMobile &&
                                      props.ispage !== "nhmap" &&
                                      item.name.length > 15
                                      ? item.name.slice(0, 15) + ".."
                                      : item.name.length >= 18
                                      ? item.name.slice(0, 18) + ".."
                                      : item.name
                                    : "Not available"}
                                </Item.Header>
                              </a>
                            </div>
                            <Item.Description className="nhmap_item-desc">
                              {display[final_index] ? (
                                <>
                                  <p className="nhpannel_npi">
                                    Overall: {npiscore}
                                  </p>
                                  <p className="nhpannel_npi">
                                    Value: {valuescore}{" "}
                                    {valuedata > 0 ? (
                                      <span className="overval">
                                        Overvalued
                                      </span>
                                    ) : valuedata < 0 ? (
                                      <span className="underval">
                                        Undervalued
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </p>
                                  {cat === "recome" && (
                                    <p className="nhpannel_npi">
                                      Personal Npi: {personalnpival}
                                    </p>
                                  )}
                                  <p className="nhpannel_npi">
                                    School: {schoolscore}
                                  </p>
                                  <p className="nhpannel_npi">
                                    Safety: {crimescore}
                                  </p>
                                  <p className="nhpannel_npi">
                                    Amenities: {amenitiesscore}
                                  </p>
                                  <p className="nhpannel_npi">
                                    Near Merchants: {townctrscore}
                                  </p>
                                  <p className="nhpannel_npi">
                                    Price: {medianprice}
                                  </p>
                                  <p className="nhpannel_npi">
                                    Public Spaces: {publicscore}
                                  </p>
                                  {/* <p className="nhpannel_npi">
                                Walkable Street: {walkablesteetscore}
                              </p> */}
                                  <p className="nhpannel_npi">
                                    Curb Appeal: {curbscore}
                                  </p>
                                  <p className="nhpannel_npi">
                                    Personal: {personalnpival}
                                  </p>
                                </>
                              ) : (
                                <>
                                  {/* <p className="nhpannel_npi">
                                    Overall: {npiscore}
                                  </p> */}
                                  {/* <p
                                    className={
                                      additional_txt || cat === "recome"
                                        ? "nhpannel_npi"
                                        : "nhpannel_value"
                                    }
                                  >
                                    Value: {valuescore}{" "}
                                    {valuedata > 0 ? (
                                      <span className="overval">
                                        Overvalued
                                      </span>
                                    ) : valuedata < 0 ? (
                                      <span className="underval">
                                        Undervalued
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </p> */}
                                  {cat === "recome" && (
                                    <p className="nhpannel_npi">
                                      Personal Npi: {personalnpival}
                                    </p>
                                  )}
                                  {additional_txt === "Value" ? (
                                    <p
                                      className={
                                        additional_txt || cat === "recome"
                                          ? "nhpannel_npi"
                                          : "nhpannel_value"
                                      }
                                    >
                                      {additional_txt}: {additional_value}{" "}
                                      {valuedata > 0 ? (
                                        <span className="overval">
                                          Overvalued
                                        </span>
                                      ) : valuedata < 0 ? (
                                        <span className="underval">
                                          Undervalued
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </p>
                                  ) : additional_txt ? (
                                    <p className="nhpannel_value">
                                      {additional_txt}: {additional_value}
                                    </p>
                                  ) : (
                                    <p
                                      className="nhpannel_value"
                                      style={{
                                        marginTop:
                                          display[final_index] ||
                                          cat === "recome"
                                            ? "0px"
                                            : "5px",
                                      }}
                                    ></p>
                                  )}
                                </>
                              )}
                              {displaydatasummary[final_summary_index] ? (
                                <>
                                  <p className="nhpannel_desc nhdesc">
                                    {final_summary}
                                    <span
                                      className="summarylessmore"
                                      onClick={(e) =>
                                        onsummaryClick(e, final_summary_index)
                                      }
                                    >
                                      {" "}
                                      ..Less
                                    </span>
                                  </p>
                                </>
                              ) : (
                                <>
                                  {final_summary != "" ? (
                                    <>
                                      {final_summary.length > 50 ? (
                                        <p
                                          className={`nhpannel_desc nhdesc ${
                                            additional_txt === "Value"
                                              ? "three-lines"
                                              : additional_txt
                                              ? "four-lines"
                                              : "four-lines"
                                          }`}
                                        >
                                          {sliceWithSpaces(
                                            final_summary,
                                            additional_txt
                                          )}
                                          <span
                                            className="summarylessmore"
                                            onClick={(e) =>
                                              onsummaryClick(
                                                e,
                                                final_summary_index
                                              )
                                            }
                                          >
                                            {" "}
                                            ...
                                          </span>
                                        </p>
                                      ) : (
                                        <p className="nhpannel_desc nhdesc">
                                          {final_summary}
                                        </p>
                                      )}
                                    </>
                                  ) : (
                                    <p className="nhpannel_desc nhdesc">
                                      {/* Best park in the peninsula.Most wonderful
                                      neighbours. */}
                                    </p>
                                  )}
                                </>
                              )}
                            </Item.Description>
                          </Item.Content>

                          {/*<ItemData
							key={index}
							href={href}
							size={item.size}
							source={'/static/images/'+item.img_name}
							head={item.neighborhood_name}
							subhead={item.subhead}
							desc={item.desc ? item.desc : null}
							extra={item.extra ? item.extra : null}
							header={header}
							customclass={customclass}
							onClick={e => getData?getData(e, item.head):e.preventDefault}
						/>*/}
                        </Item>
                      ) : (
                        <></>
                        // <Item
                        //   key={(Date.now() + item.id + index).toString()}
                        //   style={{ position: "relative" }}
                        // >
                        //   <Link>
                        //     <a
                        //       style={{ cursor: "pointer", marginRight: 20 }}
                        //       target="_blank"
                        //     >
                        //       <Item.Image
                        //         className="nhpannel_img"
                        //         src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/defaultadd.jpg`}
                        //       />
                        //     </a>

                        //     {/*<a style={{cursor:'pointer',marginRight: 20}} target="_blank"><Item.Image size='small' src={'/static/images/'+item.img_name}/></a>*/}
                        //     {/* <a style={{cursor:'pointer',marginRight: 20}} target="_blank"><Item.Image className="nhpannel_img" src='/static/images/defaultadd.jpg'/></a> */}
                        //   </Link>
                        //   <Item.Content className="right_content_top">
                        //     <Link>
                        //       <a

                        //         style={{ cursor: "pointer" }}
                        //         target="_blank"
                        //       >
                        //         <Item.Header className="nhpannel_head">
                        //           {item.name !== undefined
                        //             ? item.name
                        //             : "Not available"}
                        //         </Item.Header>
                        //       </a>
                        //     </Link>
                        //     <Item.Description className="nhmap_item-desc">
                        //       <p>Coming soon</p>
                        //     </Item.Description>
                        //   </Item.Content>
                        // </Item>
                      )}
                    </>
                  );
                }
              }
            })}
        </Item.Group>
      )}
      {itemData.length !== 0 &&
        (isMobile && props.ispage === "nhmap" ? (
          <></>
        ) : (
          <Paginate
            length={itemData.length}
            prev={prev}
            active={active}
            isEnabled={isEnabled}
            seefulllist={() => handlefilterclick()}
            {...props}
          />
        ))}
      {/* {itemData.length !== 0 &&
        props.id == "top" &&
        props.ispage &&
        props.ispage === "nhmap" && (
          <p className="seefulllist" onClick={() => handlefilterclick()}>
            See Full List
          </p>
        )} */}
    </Segment>
  );
};

NhLists.propTypes = {
  itemData: PropTypes.array.isRequired,
};

export default NhLists;
